import React, { Component } from 'react';

import moment from 'moment';

// import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
// import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
// import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    card: {
        margin: '15px',
        minWidth: '280px',
        maxWidth: '450px',
        textAlign: 'left'
    },
    cardHeader: {
        marginBottom: '10px'
    },
    grid: {
        display: 'flex',
        flexWrap: 'wrap',
        alignIitems: 'center',
        justifyContent: 'center',
        marginTop: '15px',
        paddingBottom: '100px'
    },
    header: {
        fontSize: '1.5em',
        color: "black"
    },
    headerDivider: {
        marginBottom: '15px'
    },    
    label: {
        color: 'black',
        marginRight: '5px'
    },
    root: {
        marginTop:'80px',
    }
});

class Sensors extends Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const { classes } = this.props;

        let format_time = (time) => {
            time = time.substr(0,10) + 'T' + time.substr(11,time.length-10);
            time = time.split(' ').join('');
            return moment(time).format('LLL');
        }

        let gps_time = (sensor) => {
            if (sensor.gps_time){
                let time = sensor.gps_time;
                time = time.substr(0,10) + 'T' + time.substr(11,time.length-10);
                time = time.split(' ').join('');
                return moment(time).format('LLL');    
            } else {
                return "null";
            }
        }

        let tsensors = (sensor) => {
            let list = [];
            sensor.sensors.forEach(i=>{
                if (!i.name){ i.name = '?'}
                list.push(i);
            });
            return list;
        }
        return (
            <div className={classes.root}>
                <div className={classes.header}>{this.props.texts.sensors}</div>
                {this.props.sensors.length === 0 && this.props.texts.nosensors}
                <div className={classes.grid}>
                    {this.props.sensors.length>0 &&
                        this.props.sensors && this.props.sensors.map(sensor => (
                            <Card key={sensor.uin} className={classes.card}>
                                <CardContent>
                                    <span className={classes.header}>{sensor.name}</span>
                                    <Divider className={classes.headerDivider} />

                                    <span className={classes.label}>
                                        {this.props.texts.type}:</span>
                                        {sensor._type} <br /><br />

                                    <span className={classes.label}>
                                        {this.props.texts.uin}:</span>
                                        {sensor.uin} <br />

                                    <span className={classes.label}>
                                        {this.props.texts.gps}:</span>
                                        {gps_time(sensor)} <br />

                                    <span className={classes.label}>
                                        {this.props.texts.lat}:</span>
                                        {sensor.lat} <br />

                                    <span className={classes.label}>
                                        {this.props.texts.long}:</span>
                                        {sensor.lng} <br />

                                    <br />
                                    <span className={classes.label}>
                                        {this.props.texts.tsensors}:</span>
                                        {tsensors(sensor).map((i,idx) => (
                                            <div key={idx}>
                                                <hr />
                                                <div>{i.name}</div>
                                                <div>{format_time(i.gps_time)}</div>
                                                <div>{i.sensor_value}°</div>
                                            </div>
                                        ))}
                                    {/* <br />

                                    <span className={classes.label}>
                                        {this.props.texts.speed}:</span>
                                        {sensor.speed} <br />
                                        
                                    <span className={classes.label}>
                                        {this.props.texts.volt}:</span>
                                        {sensor.voltage} */}
                                </CardContent>
                                {/* <Divider/>
                            <CardActions className='card-actions'>
                                <Button>OK</Button>
                            </CardActions> */}
                            </Card>
                        ))
                    }
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(Sensors);


// WEBPACK FOOTER //
// ./src/components/Sensors/index.js